import $ from 'jquery';
import 'block-ui';
import 'basecoat-css/basecoat';
//import 'basecoat-css/sidebar';
import 'basecoat-css/select';
import 'basecoat-css/dropdown-menu';
//import 'basecoat-css/popover'
import 'stdjs/popover';
import 'stdjs/basecoar-sidebar';
import 'basecoat-css/toast';
import 'basecoat-css/tabs';
import { initJQueryPlugin } from './stdjs/form-element';
import * as toast from 'stdjs/toast';
import { hideLoadingSpinner, showLoadingSpinner } from './stdjs/progress';

initJQueryPlugin();

$(document).ready(function() {
    
    /*
    $(document).ajaxStart(function() {
        showLoadingSpinner();
    }).ajaxStop( hideLoadingSpinner );
    */
    toast.destroyMessages();
    
    if (typeof infoMessages !== "undefined"){
        toast.showInfoMessage(infoMessages);
    }
    
    if (typeof errorMessages !== "undefined"){
        toast.showErrorMessage(errorMessages);
    }
    
    if (typeof warningMessages !== "undefined"){
        toast.showWarningMessage(warningMessages);
    }
    
    if (typeof successMessages !== "undefined"){
        toast.showSuccessMessage(successMessages);
    }
    
    if (typeof defaultMessages !== "undefined"){
        toast.showDefaultMessage(defaultMessages);
    }
});